import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

/**
 * WhatsAppShare component creates a viral sharing loop.
 * It uses a rugged design with WhatsApp green accents.
 */
export default function WhatsAppShare({ url, lang }) {
  const t = {
    es: {
      ctaText: "¿Entrenas con un amigo? Compártelo.",
      message: "¡Hey! Mira esta lista exacta de la compra del Mercadona de Barberà para quemar grasa. Vamos a hacerlo juntos: "
    },
    en: {
      ctaText: "Training with a buddy? Share this.",
      message: "Hey! Check out this exact Mercadona grocery list for Barberà to burn fat. Let's do this together: "
    }
  }[lang];

  const shareUrl = `https://wa.me/?text=${encodeURIComponent(t.message + url)}`;

  return (
    <div className="w-full mt-8">
      <a
        href={shareUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group block w-full p-4 bg-slate-900/80 weathered-border border-[#25D366]/30 hover:border-[#25D366] transition-all duration-300"
      >
        <div className="flex items-center justify-between gap-4">
          <div className="space-y-1">
            <p className="text-[#25D366] font-bold uppercase tracking-widest text-[10px]">
              {lang === 'es' ? 'Viral Loop' : 'Share the Gain'}
            </p>
            <h4 className="text-white font-display text-xl leading-none italic">
              {t.ctaText}
            </h4>
          </div>
          <div className="shrink-0 w-12 h-12 bg-[#25D366] flex items-center justify-center rounded-sm rotate-3 group-hover:rotate-0 transition-transform shadow-[0_0_15px_rgba(37,211,102,0.3)]">
            <FaWhatsapp className="text-white text-2xl" />
          </div>
        </div>
      </a>
      <p className="text-center text-[10px] text-slate-600 mt-2 uppercase font-bold tracking-tighter">
        {lang === 'es' ? 'Apoya a la comunidad local de Barberà' : 'Support the local Barberà community'}
      </p>
    </div>
  );
}